import { withAuth } from '@utilities/queries';
import { createRecentlyViewedCompany } from '@simplywallst/services';

export default async function mutationFn(payload: {
  uniqueSymbol: string;
}): Promise<void> {
  try {
    await withAuth(createRecentlyViewedCompany, payload);
  } catch (error: any) {
    let err: Error = new Error(`non axios error type: ${typeof error}`);

    if (error.isAxiosError) err = new Error('axios error');
    if (error.isAxiosError && typeof error.response !== 'undefined')
      err = new Error('axios error with no error response');
    if (
      error.isAxiosError &&
      typeof error.response !== 'undefined' &&
      Array.isArray(error.response.data?.errors)
    )
      err = new Error(
        `axios errors: ${JSON.stringify(error.response.data.errors)}`
      );

    throw err;
  }
}
